import tracksSmg from './tracks-smg.json';
import tracksSmo from './tracks-smo.json';
import tracksMk8d from './tracks-mk8d.json';
import tracksPmTok from './tracks-pmtok.json';
import tracksSm3dwBf from './tracks-sm3dwbf.json';
import tracksSmg2 from './tracks-smg2.json';
import tracksSm64 from './tracks-sm64.json';
import tracksSpm from './tracks-spm.json';
import tracksPmTtyd from './tracks-pmttyd.json';
import tracksMlBis from './tracks-mlbis.json';
import tracksDkc2 from './tracks-dkc2.json';
import tracksMlDt from './tracks-mldt.json';
import tracksDkcTf from './tracks-dkctf.json';
import tracksSmw from './tracks-smw.json';
import tracksSmw2yi from './tracks-smw2yi.json';
import tracksPm from './tracks-pm.json';
import tracksMps from './tracks-mps.json';
import tracksMrKb from './tracks-mrkb.json';

export interface Game {
	id: number;
	title: string;
	tracks: string[];
}

export const games: Game[] = [
	{
		id: 1, title: 'Super Mario Galaxy',
		tracks: tracksSmg as string[],
	},
	{
		id: 2, title: 'Super Mario Odyssey',
		tracks: tracksSmo as string[],
	},
	{
		id: 3, title: 'Mario Kart 8 Deluxe',
		tracks: tracksMk8d as string[],
	},
	{
		id: 4, title: 'Paper Mario: The Origami King',
		tracks: tracksPmTok as string[],
	},
	{
		id: 5, title: `Super Mario 3D World + Bowser's Fury`,
		tracks: tracksSm3dwBf as string[],
	},
	{
		id: 6, title: 'Super Mario Galaxy 2',
		tracks: tracksSmg2 as string[],
	},
	{
		id: 7, title: 'Super Mario 64',
		tracks: tracksSm64 as string[],
	},
	{
		id: 8, title: 'Super Paper Mario',
		tracks: tracksSpm as string[],
	},
	{
		id: 9, title: 'Paper Mario: The Thousand-Year Door',
		tracks: tracksPmTtyd as string[],
	},
	{
		id: 10, title: `Mario & Luigi: Bowser's Inside Story`,
		tracks: tracksMlBis as string[],
	},
	{
		id: 11, title: `Donkey Kong Country 2: Diddy's Kong Quest`,
		tracks: tracksDkc2 as string[],
	},
	{
		id: 12, title: `Mario & Luigi: Dream Team`,
		tracks: tracksMlDt as string[],
	},
	{
		id: 13, title: `Donkey Kong Country: Tropical Freeze`,
		tracks: tracksDkcTf as string[],
	},
	{
		id: 14, title: `Super Mario World`,
		tracks: tracksSmw as string[],
	},
	{
		id: 15, title: `Super Mario World 2: Yoshi's Island`,
		tracks: tracksSmw2yi as string[],
	},
	{
		id: 16, title: `Paper Mario`,
		tracks: tracksPm as string[],
	},
	{
		id: 17, title: `Mario Party Superstars`,
		tracks: tracksMps as string[],
	},
	{
		id: 18, title: `Mario + Rabbids Kingdom Battle`,
		tracks: tracksMrKb as string[],
	},
];

export interface Track {
	title: string;
	game: number;
}

export const dropdownList: Track[] = [];

games.forEach(game => {
	dropdownList.push(...game.tracks.map(track => ({title: `${track} - ${game.title}`, game: game.id})));
});

export interface RoundTrack {
	id: number;
	emoji: string;
	gameId: number;
	answer: string;
	audio: string;
}

export const trackList: RoundTrack[] = [
	{
		id: 1,
		emoji: '🔟',
		gameId: 10,
		answer: `Let's Meet in the Mysterious Forest`,
		audio: 'YX1TU6PuSl4.webm',
	},
	{
		id: 2,
		emoji: '9️⃣',
		gameId: 9,
		answer: 'Keelhaul Key',
		audio: 'koxlrilUyao.webm',
	},
	{
		id: 3,
		emoji: '8️⃣',
		gameId: 8,
		answer: 'Mount Lineland',
		audio: 'z2LwSGE3Gdo.webm',
	},
	{
		id: 4,
		emoji: '7️⃣',
		gameId: 7,
		answer: 'Ending',
		audio: 'Ic3_5KhR9cQ.webm',
	},
	{
		id: 5,
		emoji: '6️⃣',
		gameId: 6,
		answer: 'Starship Mario',
		audio: 'HJLhjWihpKw.webm',
	},
	{
		id: 6,
		emoji: '5️⃣',
		gameId: 5,
		answer: 'Piranha Creeper Creek',
		audio: 'aTItseJ7tKE.webm',
	},
	{
		id: 7,
		emoji: '4️⃣',
		gameId: 4,
		answer: 'Vellumental Battle',
		audio: 'xxUu7Yl1YMA.webm',
	},
	{
		id: 8,
		emoji: '3️⃣',
		gameId: 3,
		answer: 'Wireless Play',
		audio: 'TL-kakxrLzo.webm',
	},
	{
		id: 9,
		emoji: '2️⃣',
		gameId: 2,
		answer: 'Tostarena: Jaxi',
		audio: 'XVakrJqLdRw.webm',
	},
	{
		id: 10,
		emoji: '1️⃣',
		gameId: 1,
		answer: 'Catastrophe',
		audio: 'yjulWMkha4Q.webm',
	},
];
